import type { FaireProductEntity } from "../../entity_types/product";

export const p_t23t97pzcd: FaireProductEntity = {
  token: "p_t23t97pzcd",
  type: "product",
  name: "Turmeric Ginger Tin & Spoon - Organic, Fair-Trade Herbal Tea",
  brandToken: "b_cwa13pfnx9",
  brandName: "JusTea (No Import Fees to USA)",
  imageUrl:
    "https://cdn.faire.com/fastly/e455ac2d5a2313ddf3fd935b28c0d5399faecfdcd5415783df1c63d296b4cb28.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5867f3fdcc7783e47343a7d2b6133af9873ee7c98c9c3006a6ac56d7133262e1.jpeg",
    "https://cdn.faire.com/fastly/08ff079608824f073690a90570109d7d0c501cbe6dd9f5eae3733eb9daa4164b.jpeg",
    "https://cdn.faire.com/fastly/d7091187cc722f5d44d72933d0a8c715d5dcc7e5896d5b3ade43f488210ef4a2.jpeg",
    "https://cdn.faire.com/fastly/0f359bc8aa0a1bf9879a5ff369028c7740a2a9119c2af056b8474ea09eda427a.jpeg",
    "https://cdn.faire.com/fastly/064a5ba6a7630c5a9454dc7a1087b9481e8a9487640b32f809d5301567aac444.jpeg",
    "https://cdn.faire.com/fastly/7892b06d15c3bcda5f073c5776411a0c5dc564688837ceca56b2f877f265f1f4.jpeg",
    "https://cdn.faire.com/fastly/4cbe7257ecf21a1e07c64faab81da9be86fec3859f08c8e2df75317f446cb824.jpeg",
    "https://cdn.faire.com/fastly/49db14eb85b963234f249b872e9d848b23ffbef33467bc00312979288a7ec643.jpeg",
  ],
  priceDollars: 9.99,
  description:
    "WHY CUSTOMERS LOVE JUSTEA: Award-winning taste, stand-out packaging, and a farmer-direct story!\n\nTURMERIC GINGER is Aromatic & Spicy with tasting notes of Golden Turmeric & Citrus.\n\nSTAND-OUT PACKAGING: Beautiful tea tins with the farmer's picture/profile, hand-carved Kenyan spoon, and a viewing window in the lid. \n\nFARMER-DIRECT STORY: Every purchase directly supports a Women’s Herbal Tea Co-op in Kenya. Justly Made Tea.\n\nHAND-CARVED SPOON: Attached to each tin is a handcrafted, olive-wood tea spoon! Creating sustainable employment for Kenyan artisans.\n\nEARTH-FRIENDLY: Each tin is recyclable or reusable and offers up to 80 cups of loose leaf tea.\n\nHAND-PICKED TEA from Kenya: Organically grown, free of chemicals and pesticides. Non-GMO. Proud member of Fair Trade Federation.\n\n100% NATURAL INGREDIENTS: Turmeric Root, Ginger Root, Organic Lemongrass, Licorice Root, Orange Peel, Black Peppercorn, Essential Lemon Oil (Gluten/Sugar-Free and Caffeine-Free).\n\n2 YEAR SHELF LIFE Guaranteed.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:57.115Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
